import { makeMutationHook } from "utils/apolloUtils";

import { REFUND_CREATE_MUTATION } from "./mutations";
import { RefundCreate, RefundCreateVariables } from "./__generated__/mutations";

export const useRefundCreateMutation = makeMutationHook<
  RefundCreate,
  RefundCreateVariables
>(REFUND_CREATE_MUTATION);
